/**
 * @example:
 * as handlebars helper:
 * {{culture 'generic.EMPTY_LIGHTBOX'}}
 * as Vue.js mixin filter
 * {{'generic.EMPTY_LIGHTBOX' | culture}}
 */
import app from 'app';
import { SIZE } from '#/const.ts';

app.culture = {
  lang: 'en',

  get: function (path) {
    let rv = this;
    const aPath = path.split('.');

    _.each(aPath, (property) => {
      rv = rv[property];

      if (rv === undefined && this.lang === 'en') {
        if (!this.testMode) {
          app.doctorController.report(`app.culture.get path: ${path}`);
        }
        return false; // break
      }
    });

    return rv;
  },
  alert: {
    TIMELINE_IS_EMPTY_TITLE: 'Your video timeline is empty',
    TIMELINE_IS_EMPTY_DESC_PREVIEW:
      'Please add at least one asset from the Lightbox to preview the video',
    TIMELINE_IS_EMPTY_DESC_NBT:
      'Please fill the timeline with assets from the Lightbox before you can produce your video',
    TIMELINE_IS_EMPTY_DESC_TBT:
      'Please add at least one asset from the Lightbox to produce the video',
    TIMELINE_HAS_GAPS_TITLE: 'Your video timeline has gaps',
    TIMELINE_HAS_GAPS:
      'Please fill all the gaps in the timeline with assets from the Lightbox before you can produce your video',
    CHANGES_FAILED_TO_SAVE:
      'Sorry, your changes failed to save. Please try again.',
    TWITTER_VIDEO_TO_LONG: 'Video too long',
    TWITTER_VIDEO_TO_LONG_DESC:
      'Unfortunately, you can only upload videos up to 15MB in size and 30 seconds or less in length to Twitter',
    UNKNOWN_PROGRAMMER: "Story programmer didn't match to user programmer.",
    OLD_AUDIO_TITLE: 'Make sure you are using the correct narration',
    OLD_AUDIO_DESC:
      'It looks like this audio file may be old. Make sure it’s the correct file before continuing.',
    STORY_TOO_LONG_TITLE: 'Video too long...',
    STORY_TOO_LONG_TIMELINE_DESC1:
      'Video exceeds {0} limit. Please adjust timeline.',
    STORY_TOO_LONG_TIMELINE_DESC2: `
      Sorry, the video length should be up to {0} minutes long.
      <br/>Please shorten your video, or if you need longer format, 
    `,
    STORY_TOO_LONG_TIMELINE_CSM:
      'Hi,\nI would like to produce a video longer than {0}',
    TINYMCE_LOAD_ERROR: "Couldn't load text overlay editor ('tinyMCE')",
    STORY_DURATION_SOFT_TITLE: 'Preview Might Take a While',
    STORY_DURATION_SOFT_DESC:
      'Your video is longer than {0}, so it will take a bit longer to process the preview.<br>Hang in there, it’s worth the wait!',
  },

  settingsPage: {
    MULTIPLE_STUDIOS: 'Multiple Studios',
  },

  toolbox: {
    videoDisplayTimeTooltip: 'Post Production Duration',
    videoDisplayTime: 'Estimated:',
    name: 'Music',
  },

  popover: {},

  tooltip: {
    CHOOSE_DISABLE_TOOLTIP: 'No images or videos to set as thumbnail',
    NO_RECOMMENDATION_TOOLTIP: 'Currently not available',
  },

  dialog: {
    deleteStory: 'You are about to permanently delete this video',
  },

  confirm: {
    rebrandingVideo: {
      title: 'Your video is ready to be rebranded',
      caption:
        'Get the video now by using one of your *PLAN* plan monthly videos',
    },
    producingVideo: {
      title: 'Your video is ready to be produced',
      caption:
        'Get the video now by using one of your *PLAN* plan monthly videos',
    },
    coConflict: {
      title: 'Warning',
      caption: {
        default:
          'Some of the graphics or style effects in this video are not supported in the new style you have chosen. Continue anyway?',
        copy: 'This video contains either media, graphics, or music that are not supported in the brand you have chosen. This may impact the duplicated video. Continue anyway?',
      },
    },
  },

  generic: {
    EXIT: 'Exit',
    SEARCH: 'Search',
    HOME: 'Home',
    APPLY: 'Apply',
    CANCEL: 'Cancel',
    RESET: 'Reset',
    YES: 'Yes',
    ALL: 'All',
    NO: 'No',
    NEW: 'New',
    SEND: 'Send',
    SELECT: 'Select',
    DATE: 'Date',
    DONE: 'Done',
    EDIT: 'Edit',
    UPDATE: 'Update',
    PRODUCE: 'Produce',
    UPLOAD: 'Upload',
    ADD: 'Add',
    REPLACE: 'Replace',
    SAVING: 'Saving',
    ACTION_PRODUCE: 'Preview & Produce My Video',
    ACTION_PRODUCE_CONTINUE: 'Produce My Video',
    ACTION_PRODUCE_SHORT: 'Preview & Produce',
    ACTION_PRODUCE_SHORT_STORY_TEMPLATE: 'Preview & Publish',
    EMPTY_LIGHTBOX: 'Your Assets Will Appear Here',
    EXPIRATION_DATE_RESTRICTIONS: 'Not for use after {0}',
    FOR_EDITORIAL_USE: 'For Editorial Use Only',
    FOR_COMMERCIAL_USE: 'Valid for Commercial Use',
    FAIR_USE_MESSAGE:
      'You acknowledge that this content accessed by you is at your own risk and you will be solely ' +
      'responsible for obtaining any necessary rights and that you will be responsible for any damage or loss to you or any other party resulting from your use therefrom.',
    PROCESSING: 'Processing...',
    CONTACT_SUPPORT: 'Contact Support',
    DUPLICATE_AND_EDIT: 'Duplicate & Edit',
    MAKE_COPY: 'Make a Copy',
    MASS_PRODUCE: 'Mass Produce',
    QUICK_TRANSLATION: 'Translate',
    USE_THIS_STORY_TEMPLATE: 'Use This Template',
    MAKE_NEW_WOCHIT: 'Start New Video',
    MAKE_NEW_STORYBOARD: 'Start New Template',
    GO_TO_HOME: 'Go to Home',
    DISCOVER_MORE_TEMPLATES: 'Discover more Templates',
    MAX_VIDEO_TITLE_EXCEEDS:
      'The video title exceeds the maximum character limit of {0}. Please edit the text and resubmit.',
    MAX_VIDEO_TITLE_REACHED:
      'The video title reached the maximum character limit of {0}.',
    GOT_IT: 'Got It',
    CLOSE: 'Close',
    storyboard: 'Template',
    OK: 'OK',
    IMREADY: "I'm Ready",
    NO_MATCH: 'Hmmm... no match',
    SEARCH_ERROR1: 'Something isn’t working…',
    SEARCH_ERROR2: 'Try search again',
    SEARCH_ERROR3: 'or refresh the page',
    TRY_ANOTHER_SEARCH: 'Try a different search',
    TRY_ANOTHER_SEARCH_OR_FILTER: 'Try a different search or filter',
    DND_INVITATION_M1: 'Drop Files here',
    DND_INVITATION_M2: `Upload media files up to ${(
      SIZE.MAX_UPLOAD / 1e9
    ).toPrecision(1)} GB`,
    GALLERY_EMPTY: 'Your gallery is still empty!',
    OR_DRAG_ASSETS: 'or drag your media assets here',
    NO_RESULTS: 'No Results',
    NO_POSTS_YET: 'No posts yet',
    NO_FAVORITES_YET: 'No Favorites Yet',
    NO_FAVORITES_YET_DESCRIPTION:
      'Mark your favorite assets and they’ll show up here',
    UNDO: 'Undo',
    NOTE: 'Note',
    EDIT_VIDEO: 'Edit Video',
    SAVE: 'Save',
    EDIT_STORYBOARD: 'Edit Template',
  },

  flow: {
    SEGMENTATION: 'Script & Voice Over',
    SEND_TO_NARRATION: 'Send to Pro VO',
    RESEND_TO_NARRATION: 'Send Back to Pro VO',
    RESEND_TO_NARRATION2: 'Send Back to Voice Over',
    RESEND_TO_NARRATION_BEST:
      'For best results, specify your reason for sending back to voice over',
    RESEND_TO_CREATOR: 'Send Back to Creator',
    RESEND_TO_CREATOR_COMMENT: 'Please add a comment for the creator',
    ASSET_MODERATION: 'Media Selection',
    NARRATION: 'Script & Voice Over',
    VIDEO_MODERATION: 'Timeline',
  },

  emptySearchPage: {
    TITLE: 'Sorry, no results',
    SEARCH_TITLE: 'Try a different search or filter',
    SEARCH_VIDEOS: ' any videos ',
    BODY: '',
  },

  emptyPage: {
    TITLE: 'Your gallery is still empty',
    BODY: 'Add a personal touch, include your own media assets in videos',
  },

  notificationMessages: {
    EMAIL_NOT_VERIFIED1: 'Welcome Back! You have ',
    EMAIL_NOT_VERIFIED1_FIRSTIMEUSER: 'Welcome to Wochit! You have ',
    EMAIL_NOT_VERIFIED2: 'days to activate your account',
    RESEND_EMAIL: ' Resend email',
    EMAIL_WAS_SENT: 'Email was sent',

    CONNECTION_ESTABLISHED: 'We are back!',
    CONNECTION_LOST_OFFLINE:
      'It seems you are offline. Please try to reconnect to continue creating your video',
    CONNECTION_LOST_RECONNECT:
      'Trying to reconnect <span class="js-countdown">...</span>',
    CONNECTION_LOST_SUPPORT: `We are sorry, something went wrong! 
      <a href="#" class="js-reload" data-bypass data-outside>Reload</a>`,
    CONNECTION_REAUTHENTICATE: `Looks like you’re logged-out! 
      <a href="#" class="js-login" data-bypass data-outside>Sign in</a>`,
    USER_WAS_KICKED: `
      Someone else has taken this seat.
      You were logged-out from the session.
      <a href="#" class="js-login" data-bypass data-outside>Sign in</a>`,

    SUCCESS_SETTINGS_SAVE_CHANGES: 'Your changes were saved successfully!',
  },
  assetViewsMessages: {
    SET_AS_THUMBNAIL: 'Set as Thumbnail',
  },
  story: {
    EMPTY_TITLE: 'Untitled Video',
    Failed_Producing:
      'A technical issue is preventing video production and we’re currently working on it. We’ll notify you by email once it’s fixed. Thanks for your patience.',
    autosave: {
      done: 'Saved',
      progress: 'Saving...',
      failed: 'Not Saved',
      popup: {
        failedTitle: 'Sorry, Something went wrong',
        failedText:
          'The auto-save could not capture your most recent actions. Please refresh before you continue working on your video. If this problem persists, contact support.',
        done: 'Auto-save is back! All your changes are safely saved',
      },
    },
    deleteError: 'Story is no longer available for use.',
    changeStyle: {
      title: 'Choose Video Brand',
      uploading:
        'You can switch brand only when your assets upload is finished',
      noUploading: '',
    },
  },
  userUploads: {
    regularTitle: 'Uploads',
    embeddedTitle: 'My Library',
  },
  mediaFilteringContentFamily: {
    Editorial_and_Creative: 'All',
    Editorial: 'Editorial',
    Creative: 'Creative',
  },
  fullPreview: {
    HAS_GAPS:
      'There are gaps on your timeline. Fill them with media before you produce.',
    GENERATING_PREVIEW: 'Generating Preview',
    COPY_GENERATING: 'Generating link...',
    COPY_PREVIEW: 'Copy Link',
    COPIED: 'Link Copied',
    PRODUCE_BUTTON: 'Produce My Video',
    GOFROM_PREVIEW: 'Continue',
    BACKTO_PREVIEW: 'Back to Preview',
    STORYBOARD_PAGE_TITLE: 'Last Thing Before Publishing...',
    CATEGORIES_DESCRIPTION:
      'Mark all items that are relevant to this template.',
    CATEGORIES_HINT: '(Check at least one)',
    PRODUCE_TEMPLATE_BUTTON: 'Produce Template',
    CANCEL_BUTTON: 'Cancel',
    PREVIEW_VIDEO_ERROR: 'Sorry, something went wrong',
    PREVIEW_VIDEO_ERROR_DESCRIPTION: 'If problem occurs again, please ',
    PREVIEW_VIDEO_ERROR_SUPPORT: 'contact support',
    PREVIEW_VIDEO_ERROR_INTERCOM:
      'Hi,\n' +
      'My video preview has failed, can you please check?\n' +
      'Video ID: {0}\n' +
      '\n' +
      'Thanks\n',
    THUMBNAIL_OR: 'or',
    THUMBNAIL_CHOOSE: 'Choose Thumbnail',
    THUMBNAIL_REPLACE: 'Replace Thumbnail',
    THUMBNAIL_MAKE_SNAPSHOT: 'Capture',
    CAPTURE_GAPS_TOOLTIP:
      'Snapping will be available as soon as your timeline has no gaps',
    CAPTURE_RENDER_TOOLTIP:
      'Snapping will be available once preview is rendered',
    MISSING_THUMBNAIL: 'Select Thumbnail',
    CHOOSE_DISABLE_TOOLTIP: 'No images or videos to set as thumbnail',
    SHARE_YOUR_STORY: 'Share Your Draft',
    DO_NOT_SHOW_ME_AGAIN: 'Don’t show me again',
    PREVIEW_OVERRIDES_WARNING_TITLE: 'Sharing Video Preview',
    PREVIEW_OVERRIDES_WARNING_DESC:
      'When you share a video, the link always goes to the latest preview. Previous versions of your video will not be available.',
    PREVIEW_GOT_IT: 'Got it',
    CC_BLOCK: 'Subtitles are not fully ready yet',
    CC_EMPTY_TRANSCRIPT:
      'You chose to have subtitles but transcript is missing from one or more files',
  },
  mustReloadPage: {
    SAVE_AND_REFRESH_BTN: 'Save and Refresh',
    REFRESH_BTN: 'Refresh',
    TITLE_TEXT: 'Looks like you caught us during improvements!',
    DESC_TEXT: 'We want to save your story to enhance your wochit experience. ',
    PROGRESS_TEXT_START:
      'Looks like you are in the middle of uploading. you can wait until progress is finished to reload.',
    PROGRESS_TEXT_END:
      'Looks like the upload has finished, you can reload the page safely now.',
    PROGRESS_TEXT_FAILED:
      'Looks like one or more of the uploads failed, try again after the reload.',
    PROGRESS_STATUS_START: 'Uploading...',
    PROGRESS_STATUS_END: 'Done',
  },

  uploadView: {
    cta: {
      desktop: 'Upload from computer',
      recordVideo: 'Record video',
      recordAudio: 'Voice-over',
      dropbox: 'Dropbox',
      onedrive: 'Micosoft OneDrive',
      youtube: 'YouTube',
      googleDrive: 'Google Drive',
    },
    infographic: {
      webpage: 'Webpage',
      map: 'Map',
    },
    title: {
      fileUploadModal_All: 'Upload visual & voice-over',
      fileUploadModal_NoAudio: 'Upload visual',
      voiceOver: 'Add Voice Over',
      youtube: 'Upload from YouTube',
      dropbox: 'Upload from Dropbox',
      onedrive: 'Upload from Microsoft OneDrive',
      google: 'Upload from Google Drive',
    },
    providerNames: {
      dropbox: 'Dropbox',
      onedrive: 'OneDrive',
    },
    filePanelHead: 'Files',
    uploadFiles: 'Upload media or audio files.',
    mediaInfo: 'Media Info',
    supportedMedia: `Video & Images up to ${(SIZE.MAX_UPLOAD / 1e9).toPrecision(
      1
    )}GB`,
    supportedAudio: `Audio up to ${(SIZE.MAX_UPLOAD_AUDIO / 1e9).toPrecision(
      1
    )}GB`,
    supportTooltipTitle: 'We support these formats:<br/><br/>',
    supportTooltipFooter: 'Need more? Contact us to add!',
    captionPlaceholder: 'Name your files',
    descriptionPlaceholder: 'Add a description…',
    attributionPlaceholder: 'Add credit…',
    attributionMode: 'Show credit at the end of the video',
    urlPlaceholder: 'Copy URL here',
    privacyLabel: 'Share with team',
    transcribeLabel: 'Transcribe videos',
    fileError: {
      empty: 'File is empty',
      bigMedia: `File is over ${(SIZE.MAX_UPLOAD / 1e9).toPrecision(1)} GB`,
      bigAudio: `File is over ${(SIZE.MAX_UPLOAD_AUDIO / 1e9).toPrecision(
        1
      )} GB`,
      format: (ext) => `${ext} type is not supported`,
    },
    error: {
      url: 'Please set a valid URL address',
      restricted:
        'We are sorry but the Upload failed due to copyright restriction',
      saving: `We encounter a problem with uploading this Youtube video - try to upload it again,
 if the problem continues please contact Wochit support`,
      unknown: 'Something went wrong, please try again later.',
    },
    waiting: 'Preparing assets, please wait...',
    genericWarning: 'Please use supported files.',
    redirectWarning:
      'You will be redirected to your library to upload long videos',
    audioInBackgroundInfo: 'Audio files are added to your Lightbox',
  },

  time: {
    second: 'Just now',
    seconds: 'Just now',
    minute: '1 min ago',
    minutes: '_ min ago',
    hour: '1 hour ago',
    hours: '_ hours ago',
    day: '1 day ago',
    days: '_ days ago',
    week: '1 week ago',
    weeks: '_ weeks ago',
    month: '1 month ago',
    months: '_ months ago',
    year: '1 year ago',
    years: '_ years ago',
  },

  masthead: {
    home: 'Home',
    inProgress: 'Drafts',
    produced: 'Produced',
    analytics: 'Analytics',
    newStory: 'Make a Wochit',
    newAiStory: 'Wochit AI Wizard',
    newStoryboard: 'New Template',
    invite: 'Invite teammate',
    discover: 'Discover',
    storyboards: 'Master Templates',
    myStoryboards: 'My Templates',
    settings: 'Settings',
    help: 'Support Center',
    logout: 'Logout',
    title: 'Type video headline...',
    titleForStoryTemplate: 'Type headline...',
    editInfoButton: 'Video Info',
    previewAndProduceButton: 'Preview & Produce',
    previewAndPublishButton: 'Preview & Publish',
    previewShortcutButton: 'Frame View',
    exitStory: 'Exit story',
  },

  mastheadMenu: {
    deleteVideo: 'Delete video',
    makeCopy: 'Make a copy',
    setAsStoryTemplate: 'Set as template',
    unsetAsStoryTemplate: 'Turn off template',
  },

  emptyLightBox: {
    title: 'Start with media',
    titleWhenFromStoryboard: 'Find Media & Replace on Timeline',
    media: 'Search media',
    voiceOver: 'Voice Over',
    upload: 'Upload or drag',
  },

  lightBox: {
    addBackgroundMusic: 'Add Music',
    emptyFooter: 'Media you select will appear here',
    emptyFooterMediaField:
      'Media you add to your story will show here (videos currently not supported)',
  },

  dashboardHome: {
    inProgress: 'Recent Drafts',
    produced: 'Recently Produced',
    showAll: 'Show all',
    myWork: 'My work only',
    emptyInProgress1: 'No drafts for now...',
    emptyInProgress2: 'It’s time to make a new Wochit!',
    emptyInProgress3: 'Once we have something new, you will see it here',
    emptyProduced1: 'No ready videos yet',
    emptyProduced2: 'Produce your videos to see them here',
    emptyStoryboards: 'Templates not found',
    emptyBoth1: 'Looks like you have no videos yet',
    emptyBoth2: 'Make a new Wochit or',
    emptyBoth3: "see your team's work",
  },

  dashboardFilter: {
    allBrands: 'All brands',
    selectBrands: 'Brands',
    type: 'Type',
    category: 'Category',
    categories: 'Categories',
    filter: 'Filter',
    filterAll: 'All',
    filterVO: 'Voice over',
    filterNoVo: 'Without voice over',
    allCategories: 'All categories',
    videoDuration: 'Video Duration',
    showing: 'Showing',
    manageTopics: 'Manage Topics',
  },

  dashboardDrafts: {
    title: 'Drafts',
    myWork: 'My work only',
    empty1: 'Looks like you don’t have any videos in progress right now',
    emptySearch1: 'Hmmm... no match',
    emptySearch2: 'Try another search or filter',
  },

  dashboardProduced: {
    title: 'Produced',
    myWork: 'My work only',
    empty1: "Looks like you haven't produced any videos yet",
    empty2: 'Produced videos will appear here',
    emptySearch1: 'Hmmm... no match',
    emptySearch2: 'Try another search or filter',
  },
  dashboardDiscover: {
    title: 'Ready to Publish',
    titleExplanation: 'Make these stories your own.',
    empty2title: 'Hmmm…. No match',
    empty2subtitle: 'Let’s try a different search or filter',
    allProductionLines: 'All Production Lines',
    selectProductionLines: 'Production Lines',
  },
  storyboards: {
    title: 'Templates',
    storyboardCreatorTitle: 'Published Templates',
    emptyTitle: 'Hmmm...',
    emptySubtitle: "Let's try a different search or filter",
    brand: 'Brand',
    productionLine: 'Production Line',
    seeExamples: 'See video examples',
    delete: 'Delete template',
    deletePopupTitle: 'Delete template?',
    deletePopupDescription:
      'Template will not be available anymore. Videos already created based on this template will not be affected.',
    deletePopup: 'Yes, delete',
    deleteError: 'Template is no longer available for use.',
    shareOnSlack: 'Share on Slack',
    publish: 'Publish',
    shortcut: 'Frame',
    published2frame_no: 'Not Published To Frame',
    published2frame_yes: 'Published To Frame',
    shortcutExplain: 'Make template available for Frame users',
    shortcutWithoutAudio:
      'Voice over is not supported on Frame Templates. Remove VO from the template to be able to publish',
    massProduce: 'Mass Production API',
    massProduceExplain:
      'Make template available for videos auto-generated in bulk',
    editThisStoryboard: 'Edit Template',
    editThisStoryboardDescription:
      'Template will enter draft mode and will not be available to other users while being edited.',
    editThisStoryboardOk: 'OK, Go to Edit',
    add2MyTemplates: 'Add to My Templates',
    copy2MyTemplates: 'Copy & Edit',
  },
  dashboardAnalytics: {
    title: 'Analytics',
    serverDown1: 'Sorry...',
    serverDown2: 'Analytics Service is temporarily down.',
    serverDown3: 'Please try again later.',
  },
  voSelector: {
    noVo: 'Regular',
    vo: 'Voice Over',
    radio: 'Radio',
  },
  dashboardMakeNewWochit: {
    title1: 'Make a New',
    title2: 'Wochit!',
    makeNew: 'Start New Video',
    startFromExisting: 'Ready-Made Videos: New stories published daily.',
    startFromExistingDo: 'Discover',
  },
  storyPreview: {
    pendingVo: 'Pending voice over',
    voReady: 'Voice over ready',
    backToCreator: 'Sent back to creator',
    backToNarrator: 'Sent back to Pro VO',
    by: 'By',
    reason: 'Reason:',
    failed: 'Failed to produce',
    inUse: 'In use by',
    producing: 'Producing Video',
    deleting: 'Deleting…',
    rejected: 'Rejected. See comments',
    remove: 'Delete',
    copy: 'Copy',
    edit: 'Edit',
    link: 'Get a link',
  },
  confirmDelete: {
    message: 'Delete this video?',
  },
  storyVersions: {
    versionHistory: 'Version History',
    versionsCount: 'versions',
    showAllVersions: 'Show all versions',
    backToDrafts: 'Back to Drafts',
    latestPrefix: 'Latest:',
    newestFirst: 'Newest first',
    oldestFirst: 'Oldest first',
    current: 'Current',
    latest: 'Latest',
    editing: 'Editing',
    original: 'Original',
    open: 'Open',
    branch: 'Branch',
    clickToLoad: 'Click to load this version',
    branchConfirm: 'Branch this version into a separate draft?',
    branchConfirmYes: 'Branch',
    branchRootError: 'This version is already independent.',
    confirmDeleteVersion:
      'Delete this version? Other versions of this video will not be deleted.',
    confirmDeleteRoot:
      'Delete the original version? The oldest remaining version will become the original.',
    newerAvailableTitle: 'Newer versions available.',
    newerAvailableText:
      'You are viewing {version} — {count} newer versions exist.',
    deleteFolderTitle: 'Delete draft and all versions?',
    deleteFolderText:
      'This will permanently delete "{name}" and all {count}. This action cannot be undone.',
    deleteFolderConfirm: 'Delete All Versions',
    deleteLocked:
      'Someone is editing a version of this video. Please try again when they are done.',
    deleteFolderLocked:
      'A version of this story is being edited and can’t be deleted right now. Make sure it isn’t open in another tab, then try again.',
    deleteFolderNotFound:
      'Couldn’t delete the drafts folder. Please try again.',
    unknownUser: 'another user',
    aiPromptTitle: 'AI prompt',
    showMore: 'Show more',
    showLess: 'Show less',
  },
  translateStoryDialog: {
    title: 'Translate Story',
    target: 'Target language:',
    message:
      'Translate the text on your video to another language. (This currently affects only the free text, and not templated text)',
    buttonText: 'Translate',
  },
  onedriveDialog: {
    errorTitle: 'Oops, Something went wrong...',
  },
  translateOnShortcutDialog: {
    title: 'Translate Video',
    subtitle: 'Open this video on Frame for quick editing',
    buttonText: 'Continue',
  },
  makeCopyDialog: {
    title: 'Make a Copy',
    titleVideo: 'Edit with My Branding',
    titleVideoTemplate: 'Use this template',
    messageStory: 'Duplicate this draft to make additional edits',
    messageVideo: 'Duplicate this video to make additional edits',
    messageReadyMade:
      'Duplicate this video to your brand, make additional edits and produce with your branding.',
    messageVideoTemplate: 'Duplicate this template to make additional edits.',
    messageUseThis: 'Create a video based on this template and customize.',
    titleUseThis: 'Create New Video',
    storyTitle: 'Title',
    productionLine: 'Brand',
    organization: 'Workspace',
    noBrands4aspectRatio: 'No brands available for aspect ratio {0}',
    buttonText: 'Make a Copy',
    buttonTextVideo: 'Duplicate & Edit',
    buttonTextReadyMade: 'Continue',
    buttonTextVideoTemplate: 'Create Video',
  },
  makeCopyMissingVideoModal: {
    title: 'Oops, Something went wrong...',
    description: `This is awkward, but the video you are trying to use is no longer available.
              Make sure it’s there and try again.`,
  },
  setAsStoryTemplateDialog: {
    setTemplateFailedTitle: 'Something went wrong...',
    setTemplateFailedDesc:
      'The video was not set as template.<br>' +
      'Please try again, or contact support if the problem persists.',
    unsetTemplateFailedTitle: 'Something went wrong...',
    unsetTemplateFailedDesc:
      'The template was not set back to video. <br>' +
      'Please try again, or contact support if the problem persists.',
    storyboardBeingEditTitle: 'Template In Use',
    storyboardBeingEditDescription: 'Template is being edited by another user',
    unsetTemplateTitle: 'Are you sure this should not be a template?',
    setTemplateTitle: 'Are you sure this should be a template?',
    unsetTemplateConfirm: 'Yes, turn off template',
    setTemplateConfirm: 'Yes, turn on template',
  },
  makeNewWochitDialog: {
    startNewVideo: 'Create a Video',
    chooseMode: 'Choose mode',
    button: 'Create',
    cancel: 'Cancel',
  },
  makeNewStoryboardDialog: {
    selectProductionLine: 'Select Brand',
    enterStoryboardPlaceholder: 'Enter Template Name...',
    selectAspectRatio: 'Select Aspect Ratio',
    cancel: 'Cancel',
    insertTitle: 'Insert Title',
    titleError: 'Field is required',
  },
  producing: {
    infoTooltip: 'Video Info',
    subTitleHeader: 'Super! Your video is now being produced',
    subTitleLongVideo:
      'Your video is longer than {0}, so this may take a while...',
    subTitleHeaderDesc: 'We’ll notify you when it’s ready',
    subTitleHeaderStoryTemplate: 'Well Done! Your template is being generated!',
    subTitleHeaderStoryTemplateDesc:
      'It will soon be shared with your team. You can see it then on the Templates page.',
    panelAbout: 'About',
  },
  produce: {
    publishTitle: 'Publish',
    publishTemplateTitle: 'Share',
    produceTemplateTitle: 'Produce',
    panelAbout: 'About',
    download: 'Download',
    getLink: 'Get a link',
    thumbnail: 'Thumbnail',
    facebook: 'Facebook',
    twitter: 'Twitter',
    youtube: 'YouTube',
    slack: 'Slack',
    dropbox: 'Dropbox',
    onedrive: 'OneDrive',
    producedBy: 'Produced by:',
    moreInfo: 'More info',
    close: 'Close',
    goToOriginalArticle: 'Go to original article',
    showAll: 'Show all',
    cms: {
      cms: 'CMS',
      sendVideo: 'Send video to your CMS',
      sending: 'Sending...',
      sent: 'Sent to CMS!',
      automatic:
        'Your videos are automatically sent to your Content Management system.',
      dialogButton: 'OK',
      notConnectedTitle: 'CMS Not Connected',
      notConnectedBody:
        'Looks like your account is not integrated with any Content Management System. Contact your video strategist to make the connection.',
    },
    srt: 'Download Subtitles',
    srtUnavailableTitle: 'No SRT file available',
    srtUnavailableBody: 'To enable SRT for your videos, please ',
    srtContactSupport: 'contact support',
    srtIntercomMessage:
      'Hi, I would like to enable SRT subtitles for my videos.',
  },
  instantVideos: {
    pageTitle: 'Start from Ready-made Video',
    rebrand: 'Produce with My Branding',
    download: 'Download video',
    programmerName: 'Brand',
    category: 'Category',
    length: 'Length:',
    copyLink: 'Share Link',
    originalArticle: 'View original article',
    edit: 'Edit with My Branding',
    produce: 'Produce',
    shareOnSlack: 'Share on Slack',
    linkCopied: 'Link copied',
    editInformation: 'Edit Information',
    delete: 'Delete',
  },
  rebrand: {
    title: 'Quick Produce',
    message:
      'Produce this video with your branding, including your logo and closer.',
    productionLine: 'Brand',
    aspectRatio: 'Aspect Ratio',
    buttonProduce: 'Produce Now',
  },
  metadataEditor: {
    header: 'Video Information',
    titleEmpty: 'Add title...',
    descriptionEmpty: 'Add your description...',
    tagsEmpty: 'Add tags...',
    youtube: 'YouTube Channel',
    category: 'Topic',
    attribution: 'Attribution',
    autoTransition: 'Auto Transitions',
    adjustThumbnail: 'Adjust Thumbnail',
    adjustThumbnailOrTake: 'or take a snapshot when producing',
    errorRequiredField: 'Field is required',
    errorDescription: 'Please enter the description of the video',
    errorCategory: 'Please select a topic',
    missingTitle: 'Please enter video title',
    productionLine: 'Production Line',
    brandLabel: 'Brand',
    videoId: 'Video ID:',
    categories: 'Topics',
    categoriesError: 'You need to select at least one topic',
    videoThumbnail: 'Video Thumbnail',
    language: 'Language',
  },
  deletePopup: {
    message: 'Delete this video?',
    yes: 'Yes, delete',
  },
  confirmPopup: {
    areYouSure: 'Are you sure?',
    doNotAskAgain: "Don't ask me again",
    doNotShowAgain: "Don't show me again",
  },
  sendToNarratorPopup: {
    title: 'Ready to Send to Pro VO?',
    resendTitle: 'Send to Pro VO?',
    resendMessage: 'Previously recorded voice over will be discarded.',
    yes: "Yes, I'm done",
    yes2: 'Yes, Send to VO',
    no: 'Not yet',
  },

  editAssetDetails: {
    title: 'Update Media Settings',
    titlePlacholder: 'Insert title here...',
    shareLabel: 'Share With Team',
    keywordsPlaceholder: 'Add keywords',
    creditPlaceholder: 'Add credit',
    displayCredits: 'Show credit at the end of the video',
    updateError:
      'Something went wrong while trying to update settings. Please try again',
  },

  bgMusic: {
    ddlAll: 'Mood: All',
    title: 'Background Music',
    mine: 'My Uploads',
    favorite: 'Favorites',
    addMore: 'Upload',
    closeWindow: 'Close',
    infoSelected: 'In Use',
    btnUnselect: 'Unselect',
    btnSelect: 'Select',
    tip: {
      favorite: 'Add to Favorites',
      unFavorite: 'Remove from favorites',
      play: 'Play',
      pause: 'Pause',
      delete: 'Delete',
      uploadFailure: 'Upload track has failed. Please try again',
      select: 'Select music track',
      unselect: 'Unselect music track',
    },
    upload: {
      // 2026 HORIZONTAL ELLIPSIS
      inQueue: 'Queued',
      progress: 'Uploading\u2026',
      processing: 'Processing\u2026',
      failure: 'Failed to upload',
    },
    empty: {
      mine: 'You have no uploads yet',
      mineLink: 'Upload music now',
      favorite: 'Nothing on your favorites yet',
      favoriteLink: 'Show all',
      search: 'No Results',
      searchLink: 'Try a different search or filter',
    },
    confirmDelete: {
      title: 'Are you sure you want to delete this track?',
      buttonYesText: 'Delete',
      buttonNoText: 'Cancel',
    },
    tooltip: {
      on: {
        title: 'Music is on',
        fnDescription: (musicName) => `${musicName}`,
      },
      off: {
        title: '',
        description: 'Music is off',
      },
    },
  },

  slack: {
    modalTitle: 'Share on Slack',
    loginCaption: 'Start by connecting your Slack account to Wochit',
    connectButton: 'Connect to Slack',
    postButton: 'Post',
    addTeamButton: 'Add Team',
    sendToLabel: 'Send to',
    messageLabel: 'Message',
    keywordsPlaceholder: 'Users or channels...',
    keywordsMissingPlaceholder: 'Add at least one user or channel',
    searchInstruction: 'Name, @user or #channel',
    sendingPost: 'Sending video',
    shareOnSlack: 'Share on Slack',
    loading: 'Loading',
    noMatch: 'No Match',
    actionFailed: 'Action failed. Please try again or',
    contactSupport: 'contact support',
    errorIntercomMessage:
      'Hi,\n' +
      'My share to slack has failed, can you please check?\n' +
      'Video ID: {0}\n' +
      '\n' +
      'Thanks\n',
    messagePlaceholder: 'Add Note...',
  },

  frameIo: {
    share: 'Share on Frame.io',
    dialogErrorTitle: 'Something went wrong...',
    dialogErrorDesc: "Couldn't retrieve Frame.io project details.",
  },

  searchMedia: {
    disconnected: 'Looks like you got disconnected...',
    twitter: {
      title: 'Find tweets for your story',
      search: 'Search on Twitter',
    },
    instagram: {
      title: 'Find Instagram posts for your story',
      search: 'Enter a full Instagram handle (@username)',
    },
    facebook: {
      title: 'Find Facebook posts for your story',
      search: 'Search on Facebook',
    },
    creative: {
      title: 'Search for Stock Media',
    },
  },
  beats: {
    longTitle: 'Snap to Beat',
    shortTitle: 'Beats',
    disabled: 'There is no music on your video',
    loading: 'The beats are not ready yet, we are working on it',
    tooltip: {
      on: {
        title: 'Show music beats',
        description:
          'Snap clips to the beat to get the best rhythm for your video.',
      },
      off: {
        title: '',
        description: 'Click to show music beats',
      },
    },
  },
  scenes: {
    longTitle: 'Snap to Scene',
    shortTitle: 'Scenes',
    tooltip: {
      on: {
        title: 'Show scenes',
        description: 'Snap clips to scene markers for perfect synchronization',
      },
      off: {
        title: '',
        description: 'Click to show video scenes',
      },
    },
  },
  subtitles: {
    on: {
      title: 'Subtitles is on',
      description:
        'You can edit the text here. Use <b>‘Preview & Produce’</b> to see subtitles on your video.',
    },
    off: {
      title: 'Subtitles is off',
      description:
        'Turn it on to get auto transcript, and add subtitles on your video.',
    },
    working: {
      title: 'Transcribing in progress',
      description: 'Click the link to edit text.',
    },
  },
  waveform: {
    on: {
      title: 'Waveform is on',
      description: 'Click <b>‘Preview & Produce’</b> to see it on your video.',
    },
    off: {
      title: 'Waveform is off',
      description: 'Turn on to add waveform to your video.',
    },
  },
  transcribe: {
    longTitle: 'Edit Transcript',
    shortTitle: 'Subtitles',
    close: 'Close',
    resetToOriginal: 'Reset to Original',
    blankInsert: 'Click to insert transcript',
    insertText: 'Insert text',
    longTextDialogTitle: 'Are you sure you want to replace the entire text?',
    longTextDialogMessage: `Replacing the entire will regenerate the timing of the transcript.<br>
    This can result in inaccurate time codes for some of the narration.<br>
    Continue anyway?`,
    longTextDialogContinue: 'Yes, continue',
    tts: 'Time is too short for so much text! Keep it short.',
    saveFail:
      'Your last edits for the transcript were not saved. Open the transcript editor and try again',
    reset: 'Reset to Original',
    somethingWentWrong:
      'Something went wrong in the auto transcription process',
    transcribeThisVideoTxt:
      'Get auto transcript of your video. You can use it for subtitles',
    transcribeThisVideoBtn: 'Transcribe video',
    insertYourOwn: 'Insert your own script',
    inProgress: 'Transcription in progress…',
    inProgressSubtitle:
      'You can close this dialog and come back when it’s ready in a few minutes.',
    noAvailableTranscript: 'No transcript for this part',
  },
  wallpaper: {
    gradient: 'Gradient',
    title: 'Background Card',
    addTitle: 'Background card',
    brand: 'Your Brand',
    recent: 'Recent',
    custom: 'Your Custom Colors',
    empty1: 'Not seeing your brand colors?',
    empty2a: 'Contact us',
    empty2b: "and we'll setup your palette here",
    empty3: 'Colors you add will appear here',
    contactSupport:
      'Hi, I would like to setup my brand colors as my default colors. Thanks!',
  },
  sort: {
    newest: 'Newest',
    oldest: 'Oldest',
    bestMatch: 'Best Match',
    popular: 'Popular',
    favoriteAdded: 'Last Added',
    earliestAdded: 'Earliest Added',
  },
  favorite: {
    REMOVE: 'Remove From Favorites',
    ADD: 'Add to Favorites',
    FAVORITE: 'Favorite',
    PROGRESS: 'Adding To Favorites',
  },
  transition: {
    CHOOSE: 'Transitions',
    TITLE: 'Transitions Styles',
    SUB_TITLE: 'Select the transitions preset that best fits your story',
    SELECT_STYLE: 'Select a style',
    KEEP_MANUALLY: 'Keep manually selected transitions',
    PANEL_TITLE: 'Select Transition',
    PANEL_SUBTITLE: 'Transitions only show on ‘Full Preview’ of your video',
    PANEL_TOOLTIP: 'Click to change',
    SELECT_TRANSITION_IN: 'Select Transition In',
    LOCK_TRANSITION: 'Lock Transition',
    REPLACE_EXISTING: 'Changing style will replace transitions on timeline.',
    SELECT_TRANSITION_INFO:
      'Transitions are applied on the Full Preview of your video',
    LOCK_TRANSITION_INFO: 'Lock to keep your selection when replacing style',
    SUB_TITLE_INFO: 'Transitions will show on Full Preview only',
    tooltip: {
      on: {
        title: 'Transitions are on',
        description: 'See it on <b>‘Preview & Produce’</b>',
      },
      off: {
        title: '',
        description: 'Transitions are off',
      },
    },
  },
  collage: {
    link: 'Collage! See what’s new ',
    promo: 'Expand your frame with our new Collages!',
    promoDo: 'Show me how',
  },
  overlayAssets: {
    main: {
      sideBar: {
        title: 'Collage Layouts',
      },
    },
    zoom: {
      targetArea: 'Select Target Area',
    },
    categories: {
      PICTURE_IN_PICTURE: 'Picture in Picture',
      SIDE_BY_SIDE: 'Side by Side',
      TOP_BOTTOM: 'Top Bottom',
      FULL_FRAME: 'Full Frame',
      BRANDED: 'Branded',
    },
    windows: {
      SPLIT: '50:50',
      SPLIT_1_3: '70:30',
      SPLIT_2_3: '30:70',
      SPLIT_VERTICAL_1_3: '70:30',
      SPLIT_VERTICAL_2_3: '30:70',
      SPLIT_VERTICAL: '50:50',
      WIDE: 'Wide',
      SQUARE: 'Square',
      VERTICAL: 'Vertical',
    },
  },
  assetEditor: {
    audio: 'Audio',
    changeVolume: 'Change volume',
    click2Edit: 'Click to edit',
    bgMusic: 'BG Music',
    video: 'Video',
    narration: 'Voice over',
    narrationReasonTooltip: 'Voice over volume is always 100',
    overlayTracks: 'Collage video',
    overlayTracksReasonTooltip: 'Assets placed on a collage are always muted',
    cantEditVideoVolumeTooltip: 'Audio is muted when changing video speed',
    mute: 'mute',
    unmute: 'unmute',
    segmentsTitle: 'Select segments',
    resetSegment: 'Select all',
    addSegmentStatic: 'Add Segment',
    addSegmentAnime: 'Added!',
    showTranscript: 'Show transcript',
    hideTranscript: 'Hide transcript',
    objectTrackingFailedIndication:
      '** Object tracking failed - the selected area will stay in place **',
    objectTrackingFailedTitle: 'Object tracking failed',
    objectTrackingFailedText:
      'We could not save the tracked area. Please try again.',
  },
  AudioLeftBar: {
    audio: 'Sound Level Setup',
    choosePreset: 'Adjust the volume of each audio track on this scene.',
    video: 'Video',
    voiceOver: 'Voice over',
    BGMusic: 'BG Music',
    NoBGMusic: '(No music selected)',
    collageAsset: 'Collage Asset',
    overlayTracksTooltip: 'Assets placed on a Collage are always muted',
    noVideoAudioTooltip: 'Audio is muted when changing video speed',
    applyToAll: 'Apply to all assets',
    applyToAllVideos: 'Apply to all videos on your Timeline',
    applyToAllNoneVideos: 'Apply to all non-videos assets',
    appliesToTimeline: 'Applies to media on your timeline that has no sound.',
    voPlayingSettingsExplanation:
      'This setup will take place on parts of your timeline that contain voice over.',
    novoPlayingSettingsExplanation:
      'This setup will take place on parts of your timeline that not contain voice over.',
  },
  videoStyle: {
    videoStyle: 'Video Style',
    recommendedStyle: 'Change to fit your brand, or keep our recommended style',
    colorSet: 'Color palette',
    changeColors: 'Choose colors',
    resetToOriginal: 'Reset to original style',
    close: 'Close',
    selectColorPalette: 'Select color palette',
    editAnyColor: 'Click any color to edit, or pick from the list below',
    recent: 'Recent',
    featured: 'Featured',
    addColorPalette: 'Add your own palette',
    addColorPalette2: 'Create your own palette',
    chooseColors: 'Choose 2 to 4 colors to create a palette',
    cancel: 'Cancel',
    add: 'Add',
    headerFont: 'Font 1',
    bodyTextFont: 'Font 2',
    default: 'Default',
  },
};
